import React from 'react';
import { useGetCompalinWebQuery } from './CompalinWebSlice';
import { useParams } from 'react-router-dom';
import CompalinWebAction from './CompalinWebAction';

const CompalinWebDetail = () => {
    const { id } = useParams();

    const {
        data: compalinWeb
    } = useGetCompalinWebQuery('getCompalinWeb');

    return (
        <>
            <div className='container-fluid p-4'>
                <div className='row d-flex justify-content-between m-3'>
                    <h4 className='col-5'>
                        Complain Web
                    </h4>
                    <button className='col-5 col-sm-3 col-md-2 col-lg-1 btn btn-ff9b44 btn-round'
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#compalinWebAction"
                        aria-controls="compalinWebAction"
                    >Action</button>
                </div>
                <CompalinWebAction />
                {
                    compalinWeb?.map((e) =>
                        id == e?.c_id ? (
                            <div key={e?.c_id} className='row card card-body p-3'>
                                <p className='col-12'><b>Name :</b> <span>{e?.name}</span></p>
                                <p className='col-12'><b>Number :</b> <span>{e?.number}</span></p>
                                <p className='col-12'><b>Status :</b> <span>{e?.c_status}</span></p>
                                <p className='col-12'><b>Suggestion :</b> <span>{e?.complain_suggestion}</span></p>

                                <p className='col-12'>
                                    <b>Date :</b>
                                    <span>
                                        {new Date(e?.create_at).toLocaleString("en-IN", {
                                            timeZone: "Asia/Kolkata",
                                            day: "2-digit",
                                            month: "long",
                                            year: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            second: "2-digit",
                                            hour12: true,
                                        })}
                                    </span>
                                </p>
                                <p className='col-12'><b>Decription :</b> <span>{e?.decription}</span></p>
                                <p className='col-12'><b>Address :</b> <span>{e?.full_address}</span></p>
                                <p className='col-12'><b>Property Name :</b> <span>{e?.property_name}</span></p>
                                <p className='col-12'><b>Street :</b> <span>{e?.street}</span></p>
                                <p className='col-12'><b>Text :</b> <span>{e?.text}</span></p>
                            </div>
                        ) : null
                    )
                }
            </div>
        </>
    );
}

export default CompalinWebDetail;
